module.exports = __webpack_public_path__ + "static/img/index_banner7.e285904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_banner7.jpg
// module id = Az+r
// module chunks = 1